<script>
import { OPERATION, EXECUTION_MODULE, ENTITY_TYPES } from "@/views/EditConstants"

export default {
  computed: {
    retroFields() {
      var retroFields = []
      this.form.retroalimentationFields.forEach(element => {
        retroFields.push(element)
      })
      return retroFields
    },
    hasNullSectionFields() {
      return this.retroFields.find(retroField => {
          return !retroField.sectionAndFieldIds[1]
      }) ? true : false
    },
    hasNullField() {
      return this.retroFields.find(retroField => {
          return !retroField.field.toFieldId
      }) ? true : false
    },
    isEntityAbleToShowCriteriaForm() {
      return [ENTITY_TYPES.CUSTOM_ENTITY.ID, ENTITY_TYPES.SERVICE_LOCAL_ITEM.ID].includes(
        this.form.entityTypeId
      );
    },
    hasOperationsToShowCriteriaForm() {
      return [OPERATION.INSERT_OR_UPDATE, OPERATION.UPDATE, OPERATION.DELETE].includes(
        this.form.operation
      );
    },
    isInsertOperation() {
      return [OPERATION.INSERT].includes(this.form.operation);
    },
    hasAnyInsertOperation() {
      return [OPERATION.INSERT_OR_UPDATE, OPERATION.INSERT].includes(this.form.operation);
    },
    isDeleteOperationChosen() {
      return this.form.operation == OPERATION.DELETE
    },
    hasClientId() {
      return this.form.clientId;
    },
    hasActivityId() {
      return this.form.activityId;
    },
    hasEntityTypeId() {
      return this.form.entityTypeId;
    },
    hasDefaultRetroFieldsEnabled() {
      return this.hasAnyInsertOperation && this.isCustomEntityChosen
    },
    isCustomEntityChosen() {
      return this.form.entityTypeId == ENTITY_TYPES.CUSTOM_ENTITY.ID;
    },
    isAtItemFinishing() {
      
      if (this.form.executionMoment && [EXECUTION_MODULE.MOBILE, EXECUTION_MODULE.BOTH].includes(this.form.executionModule)){
        return this.form.executionMoment == 2;
      }
        
      return false;
    },
    needsCustomEntityId() {
      if (this.isCustomEntityChosen) {
        return this.form.entityId;
      }
      return true;
    },
    enableCriteriaForm() {
      return (
        this.hasOperationsToShowCriteriaForm &&
        this.hasClientId &&
        this.hasActivityId &&
        this.hasEntityTypeId &&
        this.needsCustomEntityId && 
        this.isEntityAbleToShowCriteriaForm
      );
    },
    enableRetroalimentationForm() {
      return (
        this.hasClientId &&
        this.hasActivityId &&
        this.hasEntityTypeId &&
        this.needsCustomEntityId &&
        this.hasOperationSelected &&
        !this.isDeleteOperationChosen
      );
    },
    hasOperationSelected() {
      return Boolean(this.form.operation)
    },
    isExecutionModuleNotMobile() {
      return [EXECUTION_MODULE.WATCHER, EXECUTION_MODULE.BOTH].includes(this.form.executionModule);
    },
    isExecutionModuleMobile() {
      return [EXECUTION_MODULE.MOBILE, EXECUTION_MODULE.BOTH].includes(this.form.executionModule);
    },
    isEntityTypeChosenServiceLocal() {
      return this.form.entityTypeId == ENTITY_TYPES.SERVICE_LOCAL.ID
    },
    isDeleteOperationEnabled() {
      return this.form.executionModule == EXECUTION_MODULE.WATCHER && this.form.entityTypeId == ENTITY_TYPES.SERVICE_LOCAL_ITEM.ID;
    },
    showFieldsWhenIsNotDeleteOperation() {
      return !this.isDeleteOperationEnabled && !this.isDeleteOperationChosen
    }
  },
  methods: {
    isTrashBtnDisabled(toFieldId) {      
      return this.hasDefaultRetroFieldsEnabled && ["alternativeIdentifier", "description"].includes(toFieldId)
    },
    isFormValid(){
      if (this.hasDefaultRetroFieldsEnabled && this.isDefaultFieldsValuesEmpty()) {
        this.$message({
          message: "Campo descrição e identificador alternativo são obrigatórios",
          type: "error"
        });
        return false
      }
      if (this.hasMediaAndDataTypeOnInsert) {
        this.$message({
          message: "Não é possível adicionar com campos mistos de dado e mídia",
          type: "error"
        });
        return false
      }
      if (!this.form.activityId) {
        this.$message({
          message: "O campo atividade é obrigatório.",
          type: "error"
        });
        return false
      }
      if (this.hasNullSectionFields || this.hasNullField) {
        this.$message({
          message: "Não é permitido retroalimentação com campos nulos.",
          type: "error"
        });
        return false
      }
      if (this.isCustomEntityChosen && !this.form.entityId) {
        this.$message({
          message: "Cadastro customizável é obrigatório.",
          type: "error"
        });
        return false
      }
      if (!this.form.operation) {
        this.$message({
          message: "Operação é obrigatória.",
          type: "error"
        });
        return false
      }

      return true
    }
  }
};
</script>
